import type { CycleProps } from 'core/domains/user';

export function getOnlyCurrentCycles(cycles: CycleProps[], currentCycle: number) {
  if (cycles) {
    const boticarioCycles = cycles.filter(
      (cy) => cy.brand === 'BOTICARIO' && cy.currentCycle === currentCycle,
    );

    const eudoraCycles = cycles.filter((cy) => cy.brand === 'EUDORA');
    return [boticarioCycles[0], eudoraCycles[0]].filter((cycle) => cycle !== undefined);
  }

  return [];
}
